module.exports = __webpack_public_path__ + "img/icon-printer-w.da8840d2.svg";